import controller from './language.controller';
import template from './language.html';
import './language.css';

const LanguageComponent = {
    bindings: {
        elements: '<',
        active: '<',
        selectedLanguage: '<',
        onChange: '&',
        onClose: '&'
    },
    controller,
    template,
};

export default LanguageComponent;


//////////////////
// WEBPACK FOOTER
// ./src/language/language.component.js
// module id = 637
// module chunks = 0